import React from 'react';
import {
  ChakraProvider,
  Box,
  Text,
  Link,
  VStack,
  Code,
  Grid,
  theme,
} from '@chakra-ui/react';

function Hello() {
  return (
    <>
        <h1>Hello World</h1>
    </>
  );
}

export default Hello;
